module.exports = __webpack_public_path__ + "static/img/stoneCarving_wx.4d8c4bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/stoneCarving_wx.png
// module id = 24yu
// module chunks = 26